import request from "@/config/utils/request";

// 主合同登记-修改主合同基本信息
export function updateContractInfo(data) {
  return request({
    url: "/apis/gepma/mc/updateContractInfo",
    method: "POST",
    data
  });
}

//主合同清单-查询清单列表
export function listBill(data) {
  return request({
    url: "/apis/demo/position/qryPositionData ",
    method: "POST",
    data
  });
}

// 主合同清单-新增清单（导入）
export function addBill(data) {
  return request({
    url: "/apis/gepma/mc/addBill",
    method: "POST",
    data
  });
}

// 主合同清单-新增清单（手动）
export function addUploadBill(data) {
  return request({
    url: "/apis/gepma/mc/addUploadBill",
    method: "POST",
    data
  });
}
//主合同清单-删除清单
export function deleteBill(data) {
  return request({
    url: "/apis/gepma/mc/deleteBill",
    method: "POST",
    data
  });
}

// 税率字典数据
export function getTaxRateDict(data) {
  return request({
    url: "/apis/gepma/basic/getTaxRateDict",
    method: "POST",
    data
  });
}

// 主合同登记-查询主合同基本信息
export function getContractInfo(data) {
  return request({
    url: "/apis/gepma/mc/getContractInfo",
    method: "POST",
    data
  });
}

//主合同清单单位字典数据
export function getBasuomDict(data) {
  return request({
    url: "/apis/gepma/basic/getBasuomDict",
    method: "POST",
    data
  });
}

// 主合同-提交主合同基本信息及清单
export function submitContract(data) {
  return request({
    url: "/apis/gepma/mc/submitContract",
    method: "POST",
    data
  });
}
//报存
export function addOrEditPosition(data) {
  return request({
    url: "/apis/demo/position/addOrEditPosition",
    method: "POST",
    data
  });
}
